module.exports = __webpack_public_path__ + "assets/img/btn-view-48b2e34f.png";